import axios from "axios";
import {
  ContractUserCreateRequest,
  ContractUserEditForm,
  ContractUserEditRequest,
  ContractUserNameRequest,
} from "./ContractUserForm";
import { AxiosResponse } from "axios";
import { ApplicationApi } from "../../../Routing";
import { Utility } from "../../../utils/Utility";

/**
 * ユーザー管理 API
 */
export class ContractUserService {

  // ユーザー名一覧取得API
  findContractUserNameList = async (
    param: ContractUserNameRequest
  ): Promise<AxiosResponse> => {
    try {
      const res: AxiosResponse = await axios.post(
        ApplicationApi.contractUserName.apiUrl(),
        param
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // ユーザー情報編集取得API
  findByEditId = async (userId: string): Promise<AxiosResponse> => {
    try {
      const res: AxiosResponse = await axios.get(
        ApplicationApi.contractUserDetail.apiUrl(userId)
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

}
